<template>

   <div id="app" v-bind:class="{ios: $root.app.platform == 'ios', android: $root.app.platform == 'android', desktop: $root.app.platform == 'desktop'}">
        
        <div id="main-heading">
            <div v-if="$root.app.platform == 'desktop'" class="logo__icon"></div>
            <div class="back-wrap" v-if="$ui.backButtonState">
                <div class="back-button" @click="back()">
                    <div v-if="$root.app.platform == 'android'" class="back-button__icon">
                        <back-icon />
                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="back-button__icon"></div>
                    <div class="title nav">{{ $ui.backButtonString }}</div>
                </div>
                
            </div>
            <div class="title">{{ $ui.viewTitle }}</div>
<!--            {{ $root.user.loginType }}-->
        </div>
        <div class="loader" v-bind:class="{show: $root.loading}">
            <div class="table">
                <div class="cell">
                    <div v-if="$root.app.platform == 'android'">
<!--                        <span class="loader__text">Bezig met ophalen van gegevens</span>-->
                        <div class="indicator">
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>
                            </svg>
                        </div>
                    </div>
                    <div v-if="$root.app.platform == 'ios'">
                        <span class="loader__text" v-if="$root.app.state === 'save'">Bezig met opslaan van jouw gegevens</span>
                        <span class="loader__text" v-else>Bezig met ophalen van jouw gegevens</span>
                        <div class="ispinner ispinner--animating ispinner--gray">
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                            <div class="ispinner__blade"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay transparent" v-bind:class="{show: $root.ui.overlayToggled}">
            <div class="dialogbox" v-bind:class="{show: $root.ui.dialog.state}">
                <div class="title">{{ $root.ui.dialog.title }}</div>
                <div class="description">
                    <div v-if="$root.ui.dialog.editable != true" v-html="$root.ui.dialog.description"></div>
                    <div v-else>
                        <input v-model="$root.ui.dialog.description" type="text"/>
                    </div>
                </div>
                <div class="options-wrap" v-if="$root.ui.dialog.options" :class="'options-'+Object.keys($root.ui.dialog.options).length">
                    <div class="option" v-for="(item, index) in $root.ui.dialog.options" :class="'option-'+index">
                        <div v-if="item.action">
                            <a v-bind:href="item.action">
                                <button @click="$root.ui.dialogOptionClicked(index)">{{ item.name }}</button>
                            </a>
                        </div>
                        <div v-else>
                            <button @click="$root.ui.dialogOptionClicked(index)">{{ item.name }}</button>
                        </div>
                    </div>
                </div>
                <div v-if="$root.ui.dialog.cancellable" class="cancel">
                    <div class="option">
                        <button @click="$root.ui.hideOverlay()">Sluiten</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$root.app.platform == 'desktop'" class="desktop_breadcrumbs">
            <div class="title nav">{{ $ui.backButtonString }}</div>
        </div>
        <div class="content expand">
            <router-view/>
        </div>
    </div>
</template>

<script>
//    function priceFormat( price, format, currency ) {
//        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
//        // format - A string with a BCP 47 language tag
//        // currency - ISO 4217 currency codes
//        return new Intl.NumberFormat(format, { style: 'currency', currency: currency }).format(price);
//    }
    export default {
    name: 'App',
        data () {
            
            return {
                
            }
        },
        
        mounted(){
            
            var router = this.$router;
            var root = this.$root;
            var _this = this;
            
            this.$auth.onLoginStart(function(){
                
                root.loading = true;
            });
            
            //Check authentication
            this.$auth.authenticate(function(loggedIn){
                
                //Successful login
                if(loggedIn){
                    
                    //Load the config file
                    _this.$api.get('/app/config')
                    .then(response => {
                        
                        var data = response.data;
                        
                        root.app = data.app;
                        root.user = data.user;
                        
                        //Register platform to UI
                        var platform = root.app.platform;
                        _this.$ui.setPlatform(platform);
                        
                        //Logged in
                        router.replace({path: '/app'});
                    })
                    .catch(e => {
                        
                        _this.$ui.showDialog(
                            'Fout',
                            'Configuratie kon niet worden opgehaald.',
                            true
                        );
                    })
                    
                    root.showMenuButton = true;
                }
                
                //Turn loading screen off
                setTimeout(function(){
                    
                    root.loading = false;
                }, 500);
                
            });
            
            this.$auth.onLogout(function(){
                
                root.showMenuButton = false;
                
                router.replace({path: '/'});
            });
        },
        
        created(){
            
            
        },
        
        methods:{
            
            toggleMenu(){
                
                var toggled = this.$root.menuToggled;
                this.$root.menuToggled = (toggled ? false : true);
            },
            
            logout(){
                
                this.toggleMenu();
                this.$auth.logout();
            },
            
            back(action){
                
                //Execute 
                if(!this.$ui.backButtonActions()){
                    
                    var router = this.$router;
                    router.go(-1);
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/App.vue